function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 12.75V22H7.81C4.17 22 2 19.83 2 16.19v-3.44h9.25zM22 7.81v3.44h-9.25V2h3.44C19.83 2 22 4.17 22 7.81zM11.25 2v9.25H2V7.81C2 4.17 4.17 2 7.81 2h3.44zM22 12.75v3.44c0 3.64-2.17 5.81-5.81 5.81h-3.44v-9.25H22z"
})));